import { Controller } from '@hotwired/stimulus';

export default class BankAccountToggleController extends Controller {
  static targets = ['currentAccount', 'toggleButton'];

  toggle() {
    this.currentAccountTarget.classList.add('d-none');
    this.toggleButtonTarget.classList.add('d-none');
  }
}
